<template>
	<div class="order-payment-data">
		<div class="order-payment-col">
			<img :src="logoBank" alt="" height="41">
			<p v-if="success" class="title">¡Gracias por comprar en MI STORE!</p>
			<p v-else class="title">El pedido ha sido cancelado.</p>
			<p v-if="description" class="description">{{ description }}</p>
			<p v-else-if="gatewayTransactionId"
				class="transaction-data"
				:style="`color:${globalColors.primary}`"
			>
				Nro de Transacción: {{ gatewayTransactionId }}
			</p>
			<p v-if="success">Te enviaremos un correo electrónico cuando esté en camino.</p>
		</div>
		<div class="order-payment-col">
			<div class="container-data" v-if="!cardNumber">
				<p
					class="account-data title"
					:style="`color:${globalColors.primary}`"
				>Cuenta Bancaria Mi Store:</p>
				<p class="account-data">Nombre de Cuenta: {{ accountName }}</p>
				<p class="account-data">Nro. de Cuenta: {{ accountNumber }}</p>
			</div>
			<div v-else class="container-data">
				<p
					class="account-data title"
					:style="`color:${globalColors.primary}`"
				>Datos de Transacción:</p>
				<p class="account-data">Nro. Tarjeta: {{ cardNumber }}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'order-payment-data',
		props: {
			accountName: String,
			accountNumber: [Number, String],
			description: String,
			cardNumber: String,
			gatewayTransactionId: [Number, String],
			logoBank: String,
			success: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.order-payment-data {
		align-items: center;
		display: flex;
		justify-content: space-between;
	}

	.order-payment-col {
		max-width: 40%;
		width: 50%;
	}

	.title {
		font-family: font(avenirDemi);
		font-size: size(medium);
	}

	p {
		font-size: size(medium);
	}

	.container-data {
		border: 1px solid color(border-bottom);
		padding: 33px 0px;
		max-width: 446px;
		text-align: center;
	}

	.account {
		&-data {
			font-family: font(avenirBold);
			font-size: size(maxsmall);
			margin: 0px;

			&.title {
				margin-bottom: 25px;
			}
		}
	}

	.transaction-data {
		border: 1px solid color(defaultBlack);
		border-radius: 3px;
		font-size: size(medium);
		height: 48px;
		letter-spacing: 0;
		padding: 15px 18px;
		width: max-content;
	}
</style>


// WEBPACK FOOTER //
// order-payment-data.vue?a2c14f62